import { render, staticRenderFns } from "./playerItem.vue?vue&type=template&id=6b70674a&"
import script from "./playerItem.vue?vue&type=script&lang=js&"
export * from "./playerItem.vue?vue&type=script&lang=js&"
import style0 from "./playerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports